import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "favoriteButton", "favoriteCount"]
  static values = { 
    siteId: Number,
    isFavorited: Boolean 
  }

  connect() {
    this.updateFavoriteButton()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    this.isFavoritedValue = !this.isFavoritedValue
    this.updateFavoriteButton()
    
    // Optimistic UI update
    const currentCount = parseInt(this.favoriteCountTarget.textContent)
    this.favoriteCountTarget.textContent = this.isFavoritedValue ? currentCount + 1 : currentCount - 1
    
    // Add subtle animation
    this.cardTarget.classList.add('scale-105')
    setTimeout(() => {
      this.cardTarget.classList.remove('scale-105')
    }, 150)
  }

  updateFavoriteButton() {
    const heartIcon = this.favoriteButtonTarget.querySelector('svg')
    if (this.isFavoritedValue) {
      heartIcon.classList.remove('text-gray-400')
      heartIcon.classList.add('text-rose-500')
      heartIcon.setAttribute('fill', 'currentColor')
    } else {
      heartIcon.classList.remove('text-rose-500') 
      heartIcon.classList.add('text-gray-400')
      heartIcon.setAttribute('fill', 'none')
    }
  }

  trackView() {
    // Track when user views the business details
    if (window.gtag) {
      window.gtag('event', 'promotional_card_click', {
        'site_id': this.siteIdValue,
        'source': 'dashboard_sidebar'
      })
    }
  }
}
